// extracted by mini-css-extract-plugin
export var borderRadius = "_fd-4";
export var large = "_fd-3";
export var logoContainer = "_fd-0";
export var nameLogo = "_fd-2";
export var small = "_fd-1";